export default __webpack_public_path__ + "static/media/me-banner.adea60e3.jpg";